<template>
	<div class="navigation-drawer__user-content">
		<v-tooltip
			location="right"
			color="grey-darken-3"
			open-delay="400"
			:disabled="mobile"
			text="Notifications">
			<template v-slot:activator="{ props: tooltipProps }">
			<v-btn
				icon variant="text"
				v-bind="tooltipProps"
				@click="handleNotificationClick">
				<v-badge
					color="red-darken-4"
					:model-value="!!unreadNotificationCount"
					:content="unreadNotificationCount">
					<v-icon color="grey-darken-2">notifications</v-icon>
				</v-badge>
			</v-btn>
			</template>
		</v-tooltip>

		<v-tooltip
			location="right"
			color="grey-darken-3"
			open-delay="400"
			:disabled="mobile"
			text="Help">
			<template v-slot:activator="{ props: tooltipProps }">
			<v-btn
				icon variant="text"
				v-bind="tooltipProps"
				@click="openHelpMenu">
				<v-icon color="grey-darken-2">help</v-icon>
			</v-btn>
			</template>
		</v-tooltip>

		<v-tooltip
			location="right"
			color="grey-darken-3"
			open-delay="400"
			:disabled="mobile"
			text="Log Out">
			<template v-slot:activator="{ props: tooltipProps }">
			<v-btn
				icon variant="text"
				v-bind="tooltipProps"
				v-on:click="handleLogoutClick">
				<v-icon color="grey-darken-2" class="rotate-180">exit_to_app</v-icon>
			</v-btn>
			</template>
		</v-tooltip>

		<v-tooltip
			location="right"
			color="grey-darken-3"
			open-delay="400"
			:disabled="mobile"
			text="My Account">
			<template v-slot:activator="{ props: tooltipProps }">
			<v-btn
				icon variant="text"
				v-bind="tooltipProps"
				@click="handleAvatarClick">
				<v-avatar size="32">
					<img :src="extractUserAvatarUrl({ user: user })" alt="avatar">
				</v-avatar>
			</v-btn>
			</template>
		</v-tooltip>

		<v-dialog v-model="helpDialogOpen" max-width="400" content-class="help-fallback-dialog">
			<v-card>
				<v-card-title class="headline">Help</v-card-title>
				<v-card-text>Please contact your supervisor or desktop support for assistance.</v-card-text>
				<v-card-actions>
					<v-spacer/>
					<v-btn color="blue-darken-4" class="text-white" @click="helpDialogOpen = false">OK</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>


<script>
	import { mapActions, mapGetters, mapState } from 'vuex'
	import { VUEX_UI_SHOW_LEFT_DRAWER, VUEX_UI_HIDE_NAVIGATION_DRAWER } from '@/store/constants/ui'
	import { VUEX_AUTH_LOGOUT } from '@/store/constants/auth'
	import extractUserAvatarUrl from '@/helpers/extractUserAvatarUrl'
	import HelpDeskObserver from '@/mixins/helpDeskObserver'

	export default {
		name: 'navigation-drawer--user-content',

		data() {
			return {
				helpDialogOpen: false
			}
		},

		computed: {
			...mapGetters({
				extractUserAvatar: 'extractUserAvatar'
			}),

			...mapState({
				user: state => state.auth.currentUser,
				mobile: state => state.mobile.mobile,
				unreadNotificationCount: state => state.notifications.unseenCount,
			})
		},

		mixins: [
			HelpDeskObserver
		],

		methods: {
			extractUserAvatarUrl, 
			
			...mapActions({
				showLeftDrawer: VUEX_UI_SHOW_LEFT_DRAWER,
				closeDrawer: VUEX_UI_HIDE_NAVIGATION_DRAWER
			}),

			handleNotificationClick() {
				this.showLeftDrawer()
			},

			handleLogoutClick() {
				this.$store.dispatch(VUEX_AUTH_LOGOUT).then(() => {
					// Full page load to /login, not SPA navigation. router.replace
					// left the authenticated view mounted (it kept firing API calls
					// that 401'd, and the URL changed to /login while Manage Jobs
					// stayed on screen). A hard navigation tears everything down and
					// re-initializes the app cleanly in the logged-out state.
					window.location.assign('/login')
				})
			},

			handleAvatarClick() {
				if (this.mobile === true) return
				this.$router.push({ name: 'admin-user-edit', params: { userId: this.user.id } })
			},

			openHelpMenu() {
				if (this.mobile) {
					this.closeDrawer()
				}
				// JSD widget endpoint currently returns 404; show a temporary fallback dialog.
				this.helpDialogOpen = true
				// HelpDeskObserver.startObserver()
				// document.getElementById('jsd-widget').contentWindow.document.getElementById('help-button').click()
				// document.getElementById('jsd-widget').style.display = 'block'
			}

		},

	}
</script>